export const EXTERNAL_URLS = {
  pricing: "https://meetwithfocal.com/pricing",
} as const;
